'use client';

import { useEffect, useState } from 'react';

import { useRouter } from 'next/navigation';

import { FaGift } from 'react-icons/fa6';

import SlotCounter from 'react-slot-counter';

import { routes } from '@/features/v2/constants/routes';
import { core } from '@/features/v2/home/components/privateHome/components/cardCarousel/localization/core';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

async function getJackpotAmount(id: string) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_RESPONSE_URL}/api/integrations/casino/jackpots?id=${id}`,
    { next: { revalidate: 900 } },
  );
  const json = await res.json();
  return json.total_prize_pool.amount.toString();
}

export const CardJackpots = () => {
  const router = useRouter();
  const [jackpotAmount, setJackpotAmount] = useState('0');
  const [isLoading, setIsLoading] = useState(true);
  const id = process.env.NEXT_PUBLIC_JACKPOT_ID ?? '';

  useEffect(() => {
    const fetchJackpot = async () => {
      if (id) {
        try {
          const amount = await getJackpotAmount(id);
          setJackpotAmount(amount);
        } catch (error) {
          console.warn('Error fetching jackpot:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchJackpot();
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-4" />
          <div className="h-4 bg-gray-200 rounded w-full mb-2" />
          <div className="h-4 bg-gray-200 rounded w-2/3" />
        </div>
      </div>
    );
  }

  const numericAmount = parseFloat(jackpotAmount);
  const formattedAmount = numericAmount.toLocaleString('es-HN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="flex flex-col gap-4 px-2 w-80 h-60">
      <div className="flex bg-hbackground rounded-lg p-1 pr-3 items-center gap-4 w-2/3">
        <span className="bg-primary-500 flex justify-center items-center rounded-sm p-1">
          <FaGift size={20} className="text-black" />
        </span>
        <span className="font-medium text-sm capitalize text-primary-900">
          {core.cardsCarousel[1].boxTitle}
        </span>
      </div>
      <h4 className="text-2xl font-bold text-primary-900 px-3 font-title">
        {core.cardsCarousel[1].title}
        <span className="text-primary-500">
          {core.cardsCarousel[1].tilteSpan}
        </span>
      </h4>
      <p className="text-base text-primary-900 px-3 font-text leading-none">
        {core.cardsCarousel[1].text}
        <span className="font-bold px-1">
          {core.cardsCarousel[1].textSpan}
        </span>
        {core.cardsCarousel[1].continueText}
      </p>
      <div className="flex items-center gap-2 px-3 animationPulse mt-3">
        <SlotCounter
          startValue="0"
          value={formattedAmount}
          autoAnimationStart
          valueClassName="font-extrabold bg-gradient-to-l from-gradient-50 via-gradient-100 to-gradient-50 text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)] text-2xl"
          charClassName="font-extrabold bg-gradient-to-l from-gradient-50 via-gradient-100 to-gradient-50 text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)] text-2xl"
          numberClassName="font-extrabold bg-gradient-to-l from-gradient-50 via-gradient-100 to-gradient-50 text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)] text-2xl"
          separatorClassName="font-extrabold bg-gradient-to-l from-gradient-50 via-gradient-100 to-gradient-50 text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)] text-2xl"
        />
        <span className="font-extrabold bg-gradient-to-l from-gradient-50 via-gradient-100 to-gradient-50 text-transparent bg-clip-text bg-[length:200%_auto] animate-gradient drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)] text-2xl">
          $
        </span>
      </div>
      <div className="absolute bottom-6 w-40 left-2">
        <HButton
          mode="secondary"
          size="large"
          label={core.cardsCarousel[1].buttonText}
          disabled={false}
          onPress={() => {
            router.push(routes.JACKPOTS);
          }}
        />
      </div>
    </div>
  );
};
